import React from 'react'
import { RadioQuestion } from 'components/questions'
import { useGlobalState } from 'state'


type YesNoQuestionProps = {
  num: number
  content: string
}

export const YesNoQuestion = ({ num, content }: YesNoQuestionProps) => {
  const state = useGlobalState()

  return (
    <RadioQuestion num={num} content={content} items={state.scoring.getRadioItems('yesno')} row />
  )
}
